export const DRAWING_TOOL = Object.freeze({
  FREEHAND: "freehand",
  LINE: "line",
  SURFACE_LINE: "surface-line",
  ARROW: "arrow",
  DOUBLE_ARROW: "double-arrow",
  RECTANGLE: "rectangle",
  CIRCLE: "circle",
  FILL: "fill",
  ERASE: "erase"
});
